export const getUrlParams = (customSearch) => {
  let search = customSearch || window.location.search;

  // If using HashRouter, params may exist inside hash
  if (!search && window.location.hash.includes("?")) {
    search = window.location.hash.substring(window.location.hash.indexOf("?"));
  }

  return new URLSearchParams(search);
};
export const getQueryParams = () => {
  if (window.location.search) {
    return new URLSearchParams(window.location.search);
  }
  const hash = window.location.hash || "";
  const queryString = hash.includes("?") ? hash.split("?")[1] : "";
  return new URLSearchParams(queryString);
};

export const getUrlParam = (key, defaultValue = null, customSearch) => {
  const params = getUrlParams(customSearch);

  for (const [k, v] of params.entries()) {
    if (k.toLowerCase() === key.toLowerCase()) {
      return v;
    }
  }

  return defaultValue;
};

export const getAllUrlParams = (customSearch) => {
  const params = getUrlParams(customSearch);
  return Object.fromEntries(params.entries());
};
